import './index.less';


// WEBPACK FOOTER //
// ./ecology9/wea-alert-page/style/index.js